import React, { useEffect } from "react";
import Moment from "moment";
import Pagination from "../pagination/pagination";
import { useState } from "react";
import GeneralPopup from "../shared/GeneralPopup";
import { auth } from "../services/auth";
import Loader from "../shared/Loader";
import { Helmet } from "react-helmet";
import QuillEditorExtension from "../components/QuillEditorExtension";
import {
  getServices,
  getServicePages,
  getSimpleServicePages,
  addServicePage,
  updateServicePage,
  getServicePage,
} from "../services/getServicePages";
import styles from "../css/orders.module.css";

export default function ServicePage() {
  const PageSize = 15;

  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [post, setPost] = React.useState(null);

  const isAdmin = auth().isAdmin();
  const user = auth().getUser();
  const token = auth().getToken();
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [searchTmp, setSearchTmp] = useState("");
  const [sendSearch, setSendSearch] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [success, setSuccess] = useState("");
  const [sccessText, setSuccessText] = useState("");

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const [showPopup, setPopup] = useState(false);

  const initialServiceFields = [
    {
      category: "",
      title: "",
      content: "",
      order: 1,
    },
  ];

  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [subSubTitle, setSubSubTitle] = useState("");
  const [text1, setText1] = useState("");
  const [stepTitle, setStepTitle] = useState("");
  const [stepSub, setStepSub] = useState("");
  const [stepItem1, setStepItem1] = useState("");
  const [stepItem2, setStepItem2] = useState("");
  const [stepItem3, setStepItem3] = useState("");
  const [benefitTitle, setBenefitTitle] = useState("");
  const [serviceFields, setServiceFields] = useState(initialServiceFields);
  const [faqTitle, setFaqTitle] = useState("");

  const [errors, setErrors] = useState({});

  React.useEffect(() => {
    setIsLoading(true);
    if (isAdmin) {
      getSimpleServicePages(currentPage, PageSize, search, config)
        .then((response) => {
          setPost(response.data);
          setHasError(false);
        })
        .catch((error) => {
          setHasError(true);
          setError("Invalid fetching, please try again");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [currentPage, sendSearch, refresh]);

  const togglePopup = (value) => {
    setPopup(!showPopup);
  };

  const toggleEditPopup = (value) => {
    setPopup(!showPopup);
    getServicePage(value, config)
      .then((response) => {
        const {
          id,
          title,
          subTitle,
          subSubTitle,
          text1,
          stepTitle,
          stepSub,
          stepItem1,
          stepItem2,
          stepItem3,
          benefitTitle,
          serviceFields,
          faqTitle,
        } = response.data;
        setId(id);
        setTitle(title);
        setSubTitle(subTitle);
        setSubSubTitle(subSubTitle);
        setText1(text1);
        setStepTitle(stepTitle);
        setStepSub(stepSub);
        setStepItem1(stepItem1);
        setStepItem2(stepItem2);
        setStepItem3(stepItem3);
        setBenefitTitle(benefitTitle);
        let categoryServiceFieldsMap = {
          whyus: [],
          benefits: [],
          faq: [],
          amplify: [],
        };
        serviceFields.map((field) => {
          if (!field.order) {
            field.order =
              categoryServiceFieldsMap[field.category.toLowerCase()].length > 0
                ? categoryServiceFieldsMap[field.category.toLowerCase()].length + 1
                : 1;
          }
          categoryServiceFieldsMap[field.category.toLowerCase()].push(field);
        });
        const sortByOrder = (a, b) => a.order > b.order;
        const newSortedServiceFields = []
          .concat(categoryServiceFieldsMap["whyus"].sort(sortByOrder))
          .concat(categoryServiceFieldsMap["benefits"].sort(sortByOrder))
          .concat(categoryServiceFieldsMap["faq"].sort(sortByOrder))
          .concat(categoryServiceFieldsMap["amplify"].sort(sortByOrder));
        setServiceFields(newSortedServiceFields);
        setFaqTitle(faqTitle);
        handleChangeState("title", title);
        handleChangeState("subTitle", subTitle);
        handleChangeState("subSubTitle", subSubTitle);
        handleChangeState("text1", text1);
        handleChangeState("stepTitle", stepTitle);
        handleChangeState("stepSub", stepSub);
        handleChangeState("stepItem1", stepItem1);
        handleChangeState("stepItem2", stepItem2);
        handleChangeState("stepItem3", stepItem3);
        handleChangeState("benefitTitle", benefitTitle);
        handleChangeState("serviceFields", serviceFields);
        handleChangeState("faqTitle", faqTitle);
        setHasError(false);
      })
      .catch((error) => {
        setHasError(true);
        setError("Invalid fetching, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const addServicePagePopup = (value) => {
    resetFormData();
    setPopup(!showPopup);
  };

  const searchField = () => {
    setSearch(searchTmp);
    setSendSearch(!sendSearch);
    setCurrentPage(1);
  };

  const validate = () => {
    const newErrors = {};
    if (!title) newErrors.title = "Required";
    if (!subTitle) newErrors.subTitle = "Required";
    if (!subSubTitle) newErrors.subSubTitle = "Required";
    if (!text1) newErrors.text1 = "Required";
    if (!stepTitle) newErrors.stepTitle = "Required";
    if (!stepSub) newErrors.stepSub = "Required";
    if (!stepItem1) newErrors.stepItem1 = "Required";
    if (!stepItem2) newErrors.stepItem2 = "Required";
    if (!stepItem3) newErrors.stepItem3 = "Required";
    if (!benefitTitle) newErrors.benefitTitle = "Required";
    if (!faqTitle) newErrors.faqTitle = "Required";

    serviceFields.forEach((field, index) => {
      if (!field.title) newErrors[`title_${index}`] = "Required";
      if (!field.content) newErrors[`content_${index}`] = "Required";
      if (!field.order) newErrors[`order_${index}`] = "Required";
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetFormData = () => {
    setId("");
    setTitle("");
    setSubTitle("");
    setSubSubTitle("");
    setText1("");
    setStepTitle("");
    setStepSub("");
    setStepItem1("");
    setStepItem2("");
    setStepItem3("");
    setBenefitTitle("");
    setServiceFields(initialServiceFields);
    setFaqTitle("");
  };

  const handleChangeState = (name, value) => {
    if (value === undefined) {
      return;
    }
    switch (name) {
      case "title":
        setTitle(value);
        break;
      case "subTitle":
        setSubTitle(value);
        break;
      case "subSubTitle":
        setSubSubTitle(value);
        break;
      case "text1":
        setText1(value);
        break;
      case "stepTitle":
        setStepTitle(value);
        break;
      case "stepSub":
        setStepSub(value);
        break;
      case "stepItem1":
        setStepItem1(value);
        break;
      case "stepItem2":
        setStepItem2(value);
        break;
      case "stepItem3":
        setStepItem3(value);
        break;
      case "benefitTitle":
        setBenefitTitle(value);
        break;
      case "faqTitle":
        setFaqTitle(value);
        break;
    }
  };

  const handleServiceFieldChange = (index, e) => {
    const { name, value } = e.target;
    setServiceFields((prev) =>
      prev.map((field, i) => (i === index ? { ...field, [name]: value } : field))
    );
  };

  const handleAddServiceField = () => {
    setServiceFields((prev) => [
      ...prev,
      { category: "", title: "", content: "", order: prev.length },
    ]);
  };

  const handleRemoveServiceField = (index) => {
    setServiceFields((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddServicePageSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    if (id != null && id != "") {
      try {
        await updateServicePage(user, token, {
          id,
          title,
          subTitle,
          subSubTitle,
          text1,
          stepTitle,
          stepSub,
          stepItem1,
          stepItem2,
          stepItem3,
          benefitTitle,
          serviceFields,
          faqTitle,
        });
        setRefresh(!refresh);
        setPopup(!showPopup);
        setSuccessText("Successfully edited service Page!");
        setSuccess(true);
      } catch (error) {
        setSuccess(false);
      }
    } else {
      try {
        await addServicePage(user, token, {
          id,
          title,
          subTitle,
          subSubTitle,
          text1,
          stepTitle,
          stepSub,
          stepItem1,
          stepItem2,
          stepItem3,
          benefitTitle,
          serviceFields,
          faqTitle,
        });
        setRefresh(!refresh);
        setPopup(!showPopup);
        setSuccessText("Successfuly added service Page!");
        setSuccess(true);
      } catch (error) {
        setSuccess(false);
      }
    }
  };

  return (
    <section className="flex flex-col my-20 px-3 md:px-5 lg:px-5">
      <Helmet>
        <title>Dailysocialboost | Service Pages</title>
      </Helmet>
      <h2 className="text-xl font-bold my-5">Services Page</h2>
      <div className="flex flex-col gap-3">
        <div>
          <button
            className="my-2 px-8 py-2 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
            type="button"
            onClick={() => addServicePagePopup()}
          >
            Add service page
          </button>
        </div>

        <div className="px-10">
          <div
            className={`flex flex-col ${
              isLoading ? "justify-center" : hasError ? "justify-center" : "justify-center"
            }`}
          >
            {isLoading ? (
              <div className="my-5 mx-20">
                {" "}
                <Loader styles={"w-12 h-12"}></Loader>{" "}
              </div>
            ) : hasError ? (
              <div
                key={Math.random()}
                className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-500 dark:bg-gray-800 dark:text-red-400"
                role="alert"
              >
                <svg
                  aria-hidden="true"
                  className="flex-shrink-0 inline w-5 h-5 mr-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <div>
                  <span className="font-medium">Error!</span> {error}
                </div>
              </div>
            ) : null}
          </div>
          {success ? (
            <div
              className="flex p-4 mb-4 text-sm text-white rounded-lg bg-green-500 dark:bg-gray-800 dark:text-green-400"
              role="alert"
            >
              <svg
                aria-hidden="true"
                className="flex-shrink-0 inline w-5 h-5 mr-3"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <div>
                <span className="font-medium">Success!</span> {sccessText}
              </div>
            </div>
          ) : null}
        </div>
      </div>

      {/* <div className="flex flex-row items-center gap-10 py-5">
      <QuillEditorExtension
          className={`h-40 min-w-2xl`}
          type="text"
          placeholder="Search"
          autoComplete="off"
          onChange={(e) => setSearchTmp(e.target.value)}
          name="search"
          id="search"
        />
        <button
          className="my-2 px-8 py-2 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
          type="button"
          onClick={() => searchField()}
        >
          Search
        </button>
      </div> */}
      {post ? (
        post?.length > 0 ? (
          <div className="grid grid-cols-12 gap-1 my-5 border-2 border-gray-50 shadow-md p-2 rounded-xl">
            <div className="font-semibold flex flex-row items-center col-span-1">
              Service Page ID
            </div>
            <div className="font-semibold flex flex-row items-center col-span-4">Title</div>
            <div className="font-semibold flex flex-row items-center col-span-5">Sub Title</div>
            {/* <div className="font-semibold flex flex-row items-center col-span-2">Sub Sub title</div> */}
            <div className="font-semibold flex flex-row items-center col-span-1">Created</div>
            <div className="font-semibold flex flex-row items-center col-span-1"></div>
            <div className="col-span-12">
              <hr />
            </div>
            {post
              ? post?.map((item, idx) => (
                  <React.Fragment key={item?.id}>
                    <div className="grid grid-cols-12 col-span-12 gap-1 hover:bg-pink-100 transition-all">
                      <div className="flex flex-row items-center col-span-1 font-medium">
                        {item.id}
                      </div>
                      <div
                        className="flex flex-row items-center col-span-4 font-medium"
                        dangerouslySetInnerHTML={{ __html: item?.title }}
                      ></div>
                      <div
                        className="flex flex-row items-center col-span-5"
                        dangerouslySetInnerHTML={{ __html: item?.subTitle }}
                      ></div>
                      {/* <div
                        className="flex flex-row items-center col-span-2"
                        dangerouslySetInnerHTML={{ __html: item?.subSubTitle }}
                      ></div> */}
                      <div className="flex flex-row items-center col-span-1">
                        {Moment(item.created).format("YYYY-MM-DD")}
                      </div>
                      <div className="flex flex-row justify-end items-center col-span-1">
                        <button
                          className="font-semibold"
                          id={idx}
                          onClick={(e) => toggleEditPopup(item.id)}
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              : null}
          </div>
        ) : !isLoading ? (
          <div className="self-center">No Pages found!</div>
        ) : null
      ) : !isLoading ? (
        <div className="self-center">No pages yet!</div>
      ) : null}
      {showPopup ? (
        <GeneralPopup title={"Service Page Details"} closePopup={togglePopup}>
          <div className="flex flex-col md:flex-col lg:flex-col justify-center align-center lg:justify-around mt-5 lg:mt-0 gap-5 lg:gap-10">
            <div className="flex flex-col md:flex-col lg:flex-row justify-center align-center lg:justify-around border border-solid border-b-0 border-r-white border-t-0 border-r-0 border-l-0 lg:border-r-2 lg:border-l-2 lg:border-r-gray-200 lg:border-l-gray-200 rounded-3xl pb-2 gap-5 lg:gap-10">
              <div className="flex flex-col items-center border border-solid border-b-gray-350 rounded-3xl shadow-sm px-10 py-5">
                <h2 className={`${styles.ordersHeader}`}>Service Page details</h2>
                <form
                  onSubmit={handleAddServicePageSubmit}
                  className="min-w-[600px] flex flex-col content-start flex-nowrap items-center gap-y-2"
                >
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label className="py-10 font-semibold">Title</label>
                    </p>
                    <QuillEditorExtension
                      className={`py-10 min-w-2xl ${styles.ordersInput}`}
                      name="title"
                      type="text"
                      value={title}
                      onChange={(e) => handleChangeState("title", e.target.value)}
                    />
                    {errors.title && <div>{errors.title}</div>}
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>Subtitle</label>
                    </p>
                    <QuillEditorExtension
                      className={`py-10 min-w-2xl ${styles.ordersInput}`}
                      name="subTitle"
                      type="text"
                      value={subTitle}
                      onChange={(e) => handleChangeState("subTitle", e.target.value)}
                    />
                    {errors.subTitle && <div>{errors.subTitle}</div>}
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>SubSubtitle</label>
                    </p>
                    <QuillEditorExtension
                      className={`min-w-2xl ${styles.ordersInput}`}
                      name="subSubTitle"
                      type="text"
                      value={subSubTitle}
                      onChange={(e) => handleChangeState("subSubTitle", e.target.value)}
                    />
                    {errors.subSubTitle && <div>{errors.subSubTitle}</div>}
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>Text1</label>
                    </p>
                    <QuillEditorExtension
                      className={`min-w-2xl ${styles.ordersInput}`}
                      name="text1"
                      type="text"
                      value={text1}
                      onChange={(e) => handleChangeState("text1", e.target.value)}
                    />
                    {errors.text1 && <div>{errors.text1}</div>}
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>Step Title</label>
                    </p>
                    <QuillEditorExtension
                      className={`min-w-2xl ${styles.ordersInput}`}
                      name="stepTitle"
                      type="text"
                      value={stepTitle}
                      onChange={(e) => handleChangeState("stepTitle", e.target.value)}
                    />
                    {errors.stepTitle && <div>{errors.stepTitle}</div>}
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>Step Sub</label>
                    </p>
                    <QuillEditorExtension
                      className={`min-w-2xl ${styles.ordersInput}`}
                      name="stepSub"
                      type="text"
                      value={stepSub}
                      onChange={(e) => handleChangeState("stepSub", e.target.value)}
                    />
                    {errors.stepSub && <div>{errors.stepSub}</div>}
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>Step Item 1</label>
                    </p>
                    <QuillEditorExtension
                      className={`min-w-2xl ${styles.ordersInput}`}
                      name="stepItem1"
                      type="text"
                      value={stepItem1}
                      onChange={(e) => handleChangeState("stepItem1", e.target.value)}
                    />
                    {errors.stepItem1 && <div>{errors.stepItem1}</div>}
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>Step Item 2</label>
                    </p>
                    <QuillEditorExtension
                      className={`min-w-2xl ${styles.ordersInput}`}
                      name="stepItem2"
                      type="text"
                      value={stepItem2}
                      onChange={(e) => handleChangeState("stepItem2", e.target.value)}
                    />
                    {errors.stepItem2 && <div>{errors.stepItem2}</div>}
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>Step Item 3</label>
                    </p>
                    <QuillEditorExtension
                      className={`min-w-2xl ${styles.ordersInput}`}
                      name="stepItem3"
                      type="text"
                      value={stepItem3}
                      onChange={(e) => handleChangeState("stepItem3", e.target.value)}
                    />
                    {errors.stepItem3 && <div>{errors.stepItem3}</div>}
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>Benefit Title</label>
                    </p>
                    <QuillEditorExtension
                      className={`min-w-2xl ${styles.ordersInput}`}
                      name="benefitTitle"
                      type="text"
                      value={benefitTitle}
                      onChange={(e) => handleChangeState("benefitTitle", e.target.value)}
                    />
                    {errors.benefitTitle && <div>{errors.benefitTitle}</div>}
                  </div>
                  <div className={`flex flex-col gap-y-3`}>
                    <p className="pt-2">
                      <label>Service Fields</label>
                    </p>
                    {serviceFields.map((field, index) => (
                      <div className="border rounded-xl p-5 shadow-xl gap-y-2" key={index}>
                        <div className={`h-64 w-96 min-w-2xl`}>
                          <p className="py-2">
                            <label>Title</label>
                          </p>
                          <QuillEditorExtension
                            className={`min-w-2xl ${styles.ordersInput}`}
                            name="title"
                            type="text"
                            value={field.title}
                            onChange={(e) => handleServiceFieldChange(index, e)}
                          />
                          {errors[`title_${index}`] && <div>{errors[`title_${index}`]}</div>}
                        </div>
                        <div className={`h-64 w-96 min-w-2xl`}>
                          <p className="pt-4 pb-2">
                            <label>Content</label>
                          </p>
                          <QuillEditorExtension
                            className={`min-w-2xl ${styles.ordersInput}`}
                            name="content"
                            type="text"
                            value={field.content}
                            onChange={(e) => handleServiceFieldChange(index, e)}
                          />
                          {errors[`content_${index}`] && <div>{errors[`content_${index}`]}</div>}
                        </div>
                        <div className={`w-96 min-w-2xl`}>
                          <p className="pt-8 pb-2">
                            <label>Order</label>
                          </p>
                          <input
                            className={`min-w-2xl ${styles.ordersInput}`}
                            name="order"
                            type="number"
                            min={0}
                            value={field.order}
                            onChange={(e) => handleServiceFieldChange(index, e)}
                          />
                          {errors[`order_${index}`] && <div>{errors[`order_${index}`]}</div>}
                        </div>
                        <div
                          className={`flex flex-row justify-between items-baseline w-96 min-w-2xl`}
                        >
                          <select
                            name="category"
                            className="border w-48 h-8 px-2 py-1 mt-14 rounded-2xl bg-white border-pink-350"
                            onChange={(e) => handleServiceFieldChange(index, e)}
                            value={field.category}
                            data-field={field.category}
                          >
                            <option key="Benefits" value="Benefits">
                              Benefits
                            </option>
                            <option key="Faq" value="Faq">
                              Faq
                            </option>
                            <option key="Amplify" value="Amplify">
                              Amplify
                            </option>
                            <option key="WhyUs" value="WhyUs">
                              WhyUs
                            </option>
                          </select>
                          <button
                            className="my-2 px-4 py-2 uppercase rounded-3xl text-white font-semibold bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                            type="button"
                            onClick={() => handleRemoveServiceField(index)}
                          >
                            X
                          </button>
                        </div>
                      </div>
                    ))}
                    <button
                      className="my-2 px-8 py-2 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                      type="button"
                      onClick={handleAddServiceField}
                    >
                      Add Service Field
                    </button>
                  </div>
                  <div className={`h-64 w-96 min-w-2xl`}>
                    <p className="py-2">
                      <label>FAQ Title</label>
                    </p>
                    <QuillEditorExtension
                      className={`h-40 min-w-2xl ${styles.ordersInput}`}
                      name="faqTitle"
                      type="text"
                      value={faqTitle}
                      onChange={(e) => handleChangeState("faqTitle", e.target.value)}
                    />
                    {errors.faqTitle && <div>{errors.faqTitle}</div>}
                  </div>
                  <button
                    className="my-2 px-8 py-2 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                    type="submit"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </GeneralPopup>
      ) : null}
      <div className="mt-12">
        {/* <Pagination
					className="pagination-bar"
					currentPage={currentPage}
					totalCount={post ? post?.totalRecords : null}
					pageSize={PageSize}
					onPageChange={page => setCurrentPage(page)}
				/> */}
      </div>
    </section>
  );
}
